import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=f6dcfc10&scoped=true"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"
import style0 from "./Tracking.vue?vue&type=style&index=0&id=f6dcfc10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dcfc10",
  null
  
)

export default component.exports